import hans from 'antd-mobile/es/locales/zh-CN'
import hant from 'antd-mobile/es/locales/zh-TW'
import hk from 'antd-mobile/es/locales/zh-HK'
import en from 'antd-mobile/es/locales/en-US'
import kr from 'antd-mobile/es/locales/ko-KR'

export const antdLangMap = (lang) => {
  const map = {
    hans, hant, en, kr, hk
  }
  return map[lang]
}
